<template>
  <v-btn-toggle
    v-model="selectedTable"
    class="btn-toggle"
    :dense="true"
    :mandatory="true"
    active-class="btn-active"
    color="white"
    @change="onChange"
  >
    <v-btn
      v-for="toggle in toggles"
      :key="toggle.value"
      :value="toggle.value"
      :color="getBackgroundColor(toggle.value)"
      ><app-icon :color="getTextColor(toggle.value)">{{ toggle.icon }}</app-icon
      ><span :class="{ 'btn-active': selectedTable === toggle.value }">{{
        toggle.text
      }}</span></v-btn
    >
  </v-btn-toggle>
</template>

<script>
import { SubTableTypes, TableTypes } from '@/helpers/table-helper'

export default {
  props: {
    preSelectedTable: { type: String, default: SubTableTypes.enrollment.TOTAL }
  },
  data() {
    return {
      selectedTable: this.preSelectedTable
    }
  },
  computed: {
    tableTypes() {
      return TableTypes
    },
    toggles() {
      return [
        { value: 'monthly', icon: 'calendar_today', text: 'Monthly' },
        { value: 'total', icon: 'insert_chart_outlined', text: 'Current' },
        { value: 'projected', icon: 'show_chart', text: 'Projected' }
      ]
    }
  },
  methods: {
    getTextColor(chart) {
      return this.selectedTable === chart ? 'white' : 'primary'
    },
    getBackgroundColor(chart) {
      return this.selectedTable === chart ? 'primary' : 'white'
    },
    onChange() {
      this.$emit('change', this.selectedTable)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-toggle {
  .btn-active {
    color: var(--v-white-base);
  }
  :not(.btn-active) {
    color: var(--v-primary-base);
  }
  .v-btn:not(:hover)::before {
    display: none;
  }
  .v-btn:hover::before {
    opacity: 0.18;
  }
}
</style>
